// extracted by mini-css-extract-plugin
export default {"profileContentSpinner":"ProfileContent_profileContentSpinner__ZwIz7"};